import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary, BodySecondary } from '@liveauctioneers/hammer-ui-core/text';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useItemOrPriceResultLink } from '@/hooks/useItemOrPriceResultLink';
import { ItemSummary } from '@/types/item/ItemSummary';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';

export const TitleComponentSearchCard = createInfo<ItemSummary & { position: number }>({
    className: 'line-clamp-0',
    useText: ({ itemId, position, promoted, title }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const itemUrl = useItemOrPriceResultLink(itemId, true);
        const isMobile = useIsMobileLayout();

        return (
            <div className="mb-xs px-xs smMin:mb-sm smMin:px-sm">
                <SubtleMonochromeLink
                    aria-label={title}
                    className="line-clamp-2 text-sm group-[.image-hover]:text-link-hover group-[.image-hover]:underline smMin:text-base"
                    href={itemUrl}
                    onClick={() => {
                        onNavigateInitiated(ItemCardNavigationTrigger.TitleClick, { position, promoted });
                    }}
                    title={title}
                >
                    {isMobile ? <BodySecondary>{title}</BodySecondary> : <BodyPrimary>{title}</BodyPrimary>}
                </SubtleMonochromeLink>
            </div>
        );
    },
});
